import { Loader2, UploadCloud, X } from "lucide-react";

export default function ImageDropzone({ upload, preview, onClear, label, testid, compact }) {
  return (
    <>
      <input ref={upload.inputRef} type="file" accept="image/*,.heic,.heif" hidden onChange={upload.onFile} data-testid={testid} />
      {preview ? (
        <div className="relative inline-block">
          {preview}
          <button type="button" onClick={onClear}
            className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-rose-600 text-white flex items-center justify-center">
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <button type="button" onClick={upload.pick} disabled={upload.uploading}
          className={`w-full border-2 border-dashed border-slate-300 rounded-xl ${compact ? "py-5" : "py-8"} flex flex-col items-center gap-2 text-slate-500 hover:border-teal-400 hover:text-teal-600 transition-colors`}>
          {upload.uploading ? <Loader2 className="h-6 w-6 animate-spin" /> : <UploadCloud className="h-6 w-6" />}
          <span className="text-sm">{upload.uploading ? "Uploading…" : label}</span>
        </button>
      )}
    </>
  );
}
